import { Component, OnInit, OnDestroy, HostListener, ElementRef, Renderer2 } from '@angular/core'
import { ActivatedRoute } from '@angular/router'
import { ContentService } from '../../services/content/content.service'
import { Meta, Title } from '@angular/platform-browser'
import { Store } from '@ngrx/store'
import { AppState } from '../../state/app-state'
import { HiddenLoading, ShowLoading } from '../../state/loading/loading.action'
import { JsonLdService } from '../../services/json-ld/json-ld.service'
import { EVEREST_BABY_SCHEMA } from '../../schemas/everest-baby.schema'
import { EVEREST_PLUS_SCHEMA } from '../../schemas/everest-plus.schema'
import { EVEREST_SLIM_SCHEMA } from '../../schemas/everest-slim.schema'
import { EVEREST_STAR_SCHEMA } from '../../schemas/everest-star.schema'
import { EVEREST_FIT_SCHEMA } from '../../schemas/everest-fit.schema'

const SCHEMAS_BY_SLUG: Record<string, object> = {
	'everest-baby': EVEREST_BABY_SCHEMA,
	'everest-plus': EVEREST_PLUS_SCHEMA,
	'everest-slim': EVEREST_SLIM_SCHEMA,
	'everest-star': EVEREST_STAR_SCHEMA,
	'everest-fit': EVEREST_FIT_SCHEMA,
}

@Component({
	selector: 'app-interna-produto',
	templateUrl: './interna-produto.component.html',
	styleUrls: ['./interna-produto.component.scss'],
})
export class InternaProdutoComponent implements OnInit, OnDestroy {
	constructor(
		private content: ContentService,
		private route: ActivatedRoute,
		private title: Title,
		private meta: Meta,
		private store: Store<AppState>,
        private el: ElementRef,
        private renderer: Renderer2,
        private jsonLd: JsonLdService
	) {
		this.store.dispatch(ShowLoading())
	}

	ngOnDestroy(): void {
		this.jsonLd.removeSchema()
	}

    dataProduct: any
    isPlus: boolean = false
    @HostListener('window:scroll', [])


    onWindowScroll() {
        const buttonElement = this.el.nativeElement.querySelector('#btn');

        if (window.pageYOffset > 100) { // Você pode ajustar o valor 100 para a quantidade de scroll que desejar
            this.renderer.addClass(buttonElement, 'float'); // Adicione a classe CSS desejada aqui
        } else {
            this.renderer.removeClass(buttonElement, 'float'); // Remova a classe se não atender às condições
        }
    }

	ngOnInit(): void {
		const slug = this.route.snapshot.paramMap.get('slug')!
		const lang = this.route.snapshot.paramMap.get('lang')!
		const schema = SCHEMAS_BY_SLUG[slug]
		if (schema) {
			this.jsonLd.insertSchema(schema)
		}
		const self = this
		self.content.getProduct(slug, lang,{
			fnSuccess(data) {
				self.title.setTitle(data.items[0].meta.seo_title || slug)
				self.meta.addTag({
					name: 'description',
					content: data.items[0].meta.search_description,
				})
				self.meta.updateTag(
					{
						property: 'og:description',
						content: data.items[0].meta.search_description,
					},
					"property='og:description'"
				)
				self.meta.updateTag(
					{
						property: 'og:title',
						content: data.items[0].meta.seo_title,
					},
					"property='og:title'"
				)
				self.dataProduct = data.items[0]
				if (self.dataProduct.title == 'Everest Plus') {
					self.isPlus = true
				}
			},
			fnError(err) {
				console.warn(err)
			},
			fnFinalized() {
				self.store.dispatch(HiddenLoading())
			},
		})
	}
}
